import * as Yup from 'yup';

export const PrimaryCardSchema = Yup.object().shape({
  primary: Yup.string().required('Select option').typeError('Select option')
});
